module.exports = __webpack_public_path__ + "parth9.1a42e35668224c986a5c.png";


//////////////////
// WEBPACK FOOTER
// E:/Java/ResumeAngular/resume/src/assets/images/parth9.png
// module id = ../../../../../src/assets/images/parth9.png
// module chunks = main